module.exports = __webpack_public_path__ + "img/reagent-2.c50e1856.png";